import {formatDate} from 'utils/date';

const normalizeFractionalSeconds = (value: string) =>
    value.replace(/(\.\d{3})\d+(?=Z|[+-]\d{2}:\d{2}$)/, '$1');

export const formatReturnGoodsDate = (value?: string | null, dateFormat = 'dd.MM.yyyy, HH:mm') => {
    if (!value) return '—';

    const normalizedValue = normalizeFractionalSeconds(value);
    const date = new Date(normalizedValue);

    return Number.isNaN(date.getTime()) ? '—' : formatDate(date, dateFormat);
};
